import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Administracion } from '../model/administracion.model';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdministracionService {
  private apiUrl =  `${environment.apiUrl}/api/administraciones`; 


  constructor(private http: HttpClient, private authService: AuthService) {}

  // Manejo de errores
  private manejarError(error: HttpErrorResponse): Observable<never> {
    let mensaje = 'Ocurrió un error inesperado';
    if (error.error?.message) {
      mensaje = error.error.message;
    }
    const enrichedError: any = new Error(mensaje);
    enrichedError.status = error.status;
    enrichedError.url = error.url;
    enrichedError.backend = error.error;
    return throwError(() => enrichedError);
  }

  // Obtener todas las administraciones
  obtenerTodas(): Observable<Administracion[]> {
    return this.http.get<Administracion[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // Obtener una por ID (usando nit como identificador)
  obtenerPorNit(nit: number): Observable<Administracion> {
    return this.http.get<Administracion>(`${this.apiUrl}/${nit}`, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // Crear nueva administración
  crear(admin: Administracion): Observable<Administracion> {
    return this.http.post<Administracion>(this.apiUrl, admin, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // Actualizar por NIT
  actualizar(nit: number, admin: Administracion): Observable<Administracion> {
    return this.http.put<Administracion>(`${this.apiUrl}/${nit}`, admin, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // Eliminar por NIT
  eliminar(nit: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${nit}`, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }
}
